"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializationError = void 0;
class InitializationError extends Error {
    constructor(msg) {
        super(msg ? `InitializationError: ${msg}` : "InitializationError");
    }
}
exports.InitializationError = InitializationError;
//# sourceMappingURL=InitializationError.js.map